import { useState } from 'react';
import Reveal from '@/components/base/Reveal';
import SectionHeading from '@/components/base/SectionHeading';
import { faqs } from '@/mocks/drama';

export default function Faq() {
  const [open, setOpen] = useState<number | null>(0);

  return (
    <section id="faq" className="scroll-mt-32 bg-background-50 py-16 md:py-24">
      <div className="mx-auto max-w-4xl px-4 md:px-6">
        <Reveal>
          <SectionHeading
            eyebrow="常见问题"
            title="关于《欲望的诱惑》的常见疑问"
            desc="围绕集数、演员、女主角与观看方式，整理了几个最常被问到的问题。"
            align="center"
          />
        </Reveal>

        <div className="mt-12 space-y-3">
          {faqs.map((item, index) => {
            const isOpen = open === index;
            return (
              <Reveal key={item.q} delay={index * 40}>
                <div className="overflow-hidden rounded-lg border border-background-200 bg-background-100/60">
                  <button
                    type="button"
                    onClick={() => setOpen(isOpen ? null : index)}
                    aria-expanded={isOpen}
                    className="flex w-full items-center justify-between gap-4 px-5 py-4 text-left"
                  >
                    <span className="font-heading text-sm font-semibold text-foreground-950 md:text-base">
                      {item.q}
                    </span>
                    <i
                      className={`ri-add-line shrink-0 text-xl text-primary-500 transition-transform duration-300 ${
                        isOpen ? 'rotate-45' : ''
                      }`}
                    />
                  </button>
                  <div
                    className={`grid transition-all duration-300 ease-out ${
                      isOpen ? 'grid-rows-[1fr] opacity-100' : 'grid-rows-[0fr] opacity-0'
                    }`}
                  >
                    <div className="overflow-hidden">
                      <p className="px-5 pb-5 text-sm leading-relaxed text-foreground-700">{item.a}</p>
                    </div>
                  </div>
                </div>
              </Reveal>
            );
          })}
        </div>
      </div>
    </section>
  );
}